import React from "react";
import { View, Text, Image } from "react-native";

export default function Letter({ l, size }) {
  return (
    <View style={{ width: size, height: size }}>
      {l !== "?" ? (
        <Image
          source={require("../assets/letter-background.png")}
          style={{ width: size, height: size }}
        />
      ) : (
        <View
          style={{
            backgroundColor: "#F2F2F2",
            width: size - 7,
            height: size - 9,
            marginVertical: 3,
            marginHorizontal: 3,
            borderRadius: 5,
            shadowColor: "#000",
            shadowOffset: {
              width: 0,
              height: 4,
            },
            shadowOpacity: 0.25,
            shadowRadius: 3.84,
            elevation: 5,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Image
            source={require("../assets/question-mark.png")}
            style={{ width: 26, height: 46 }}
          />
        </View>
      )}
      <Text
        style={{
          position: "absolute",
          width: size,
          textAlign: "center",
          top: size / 3 - size / 4,
          fontSize: size / 1.5,
          fontWeight: "800",
          opacity: l === "?" ? 0.15 : 0.5,
          textShadowColor: "rgba(0, 0, 0, .5)",
          textShadowOffset: { width: -1, height: 1 },
          textShadowRadius: 10,
          fontFamily: "Times",
        }}
      >
        {l === "?" ? "" : l.slice(0, 1)}
      </Text>
    </View>
  );
}
